import axiosInstance from '@/shared/api/axios';
import type {
  ApiPartiesAddPackagePostBody,
  ApiPartiesAddPackagePostResponse,
  ApiPartiesGetItem,
  ApiPartiesListParams,
  ApiPartiesListResponse,
  ApiPartiesPostBody,
  ApiPartiesStatusPatchBody,
  ApiPartyDetail,
} from '@/shared/types/api/parties';

export const apiPartiesListGet = async (
  params: ApiPartiesListParams,
): Promise<ApiPartiesListResponse> => {
  const { data } = await axiosInstance.get<ApiPartiesListResponse>('/parties', { params });
  return data;
};

export const apiPartiesDetailGet = async (id: string): Promise<ApiPartyDetail> => {
  const { data } = await axiosInstance.get<ApiPartyDetail>(`/parties/${id}`);
  return data;
};

export const apiPartiesPost = async (body: ApiPartiesPostBody): Promise<ApiPartiesGetItem> => {
  const { data } = await axiosInstance.post<ApiPartiesGetItem>('/parties', body);
  return data;
};

export const apiPartiesStatusPatch = async (
  id: string,
  body: ApiPartiesStatusPatchBody,
): Promise<ApiPartiesGetItem> => {
  const { data } = await axiosInstance.patch<ApiPartiesGetItem>(`/parties/${id}/status`, body);
  return data;
};

export const apiPartiesDelete = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/parties/${id}`);
};

export const apiPartiesAddPackage = async (
  id: string,
  body: ApiPartiesAddPackagePostBody,
): Promise<ApiPartiesAddPackagePostResponse> => {
  const { data } = await axiosInstance.post<ApiPartiesAddPackagePostResponse>(
    `/parties/${id}/packages`,
    body,
  );
  return data;
};

export const apiPartiesRemovePackage = async (id: string, packageId: string): Promise<void> => {
  await axiosInstance.delete(`/parties/${id}/packages/${packageId}`);
};

export const apiPartiesManifestGet = async (id: string): Promise<Blob> => {
  const { data } = await axiosInstance.get<Blob>(`/parties/${id}/manifest`, {
    responseType: 'blob',
  });
  return data;
};
